import React from 'react';
import { Link } from 'react-router-dom';

// ==========================================
// LAYOUT PARTAGÉ POUR TOUS LES ARTICLES DU BLOG
// Garantit une mise en page cohérente (header, corps, CTA)
// sur l'ensemble des articles.
// ==========================================

export const blogStyles = {
  page: {
    fontFamily: '"Inter", sans-serif',
    color: '#0B1F3A',
    background: '#FFFFFF',
    minHeight: '100vh',
  },
  hero: {
    background: '#0B1F3A',
    color: '#FFFFFF',
    padding: '70px 20px 50px',
  },
  heroInner: {
    maxWidth: '760px',
    margin: '0 auto',
  },
  backLink: {
    color: '#F5F7FA',
    opacity: 0.8,
    textDecoration: 'none',
    fontSize: '14px',
    display: 'inline-block',
    marginBottom: '20px',
  },
  tagPill: {
    display: 'inline-block',
    background: 'rgba(255,255,255,0.1)',
    color: '#FFFFFF',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    marginBottom: '18px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  h1: {
    fontSize: '36px',
    fontWeight: 800,
    margin: '0 0 16px 0',
    lineHeight: 1.25,
  },
  meta: {
    fontSize: '14px',
    color: '#F5F7FA',
    opacity: 0.7,
  },
  body: {
    maxWidth: '760px',
    margin: '0 auto',
    padding: '50px 20px 80px',
    fontSize: '17px',
    lineHeight: 1.7,
  },
  intro: {
    fontSize: '19px',
    opacity: 0.85,
    marginBottom: '30px',
  },
  h2: {
    fontSize: '24px',
    fontWeight: 700,
    marginTop: '44px',
    marginBottom: '16px',
    color: '#0B1F3A',
  },
  ul: {
    paddingLeft: '22px',
    marginBottom: '18px',
  },
  li: {
    marginBottom: '8px',
  },
  link: {
    color: '#6C5CE7',
    fontWeight: 600,
  },
  ctaBox: {
    marginTop: '56px',
    background: '#F5F7FA',
    borderRadius: '12px',
    padding: '32px',
    textAlign: 'center',
  },
  ctaTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  ctaText: {
    fontSize: '16px',
    opacity: 0.8,
    marginBottom: '22px',
  },
  ctaButton: {
    display: 'inline-block',
    padding: '14px 28px',
    fontSize: '16px',
    fontWeight: 'bold',
    borderRadius: '8px',
    background: '#6C5CE7',
    color: 'white',
    textDecoration: 'none',
    boxShadow: '0 4px 15px rgba(108, 92, 231, 0.35)',
  },
  ctaSecondary: {
    display: 'block',
    marginTop: '14px',
    fontSize: '14px',
    color: '#0B1F3A',
    opacity: 0.6,
    textDecoration: 'underline',
  },
  disclaimer: {
    marginTop: '30px',
    fontSize: '13px',
    opacity: 0.55,
    fontStyle: 'italic',
  },
};

export default function BlogArticleLayout({
  tag,
  title,
  date,
  children,
  ctaTitle = 'Quels référentiels s\'appliquent à votre entreprise ?',
  ctaText = 'Réalisez votre pré-audit cybersécurité gratuit et identifiez en quelques minutes vos écarts sur le RGPD, NIS2 et ISO 27001.',
  ctaPrimaryLabel = 'Réaliser mon diagnostic gratuit',
  ctaPrimaryTo = '/register',
  ctaSecondaryLabel = 'Découvrir l\'offre Audit Cyber Pro',
  ctaSecondaryTo = '/pricing',
}) {
  return (
    <div style={blogStyles.page}>
      <header style={blogStyles.hero}>
        <div style={blogStyles.heroInner}>
          <Link to="/blog" style={blogStyles.backLink}>← Retour au blog</Link>
          <div style={blogStyles.tagPill}>{tag}</div>
          <h1 style={blogStyles.h1}>{title}</h1>
          <div style={blogStyles.meta}>Publié le {date}</div>
        </div>
      </header>

      <article style={blogStyles.body}>
        {children}

        <div style={blogStyles.ctaBox}>
          <div style={blogStyles.ctaTitle}>{ctaTitle}</div>
          <p style={blogStyles.ctaText}>{ctaText}</p>
          <Link to={ctaPrimaryTo} style={blogStyles.ctaButton}>{ctaPrimaryLabel}</Link>
          <Link to={ctaSecondaryTo} style={blogStyles.ctaSecondary}>{ctaSecondaryLabel}</Link>
        </div>
      </article>
    </div>
  );
}
